type Environment = "development" | "production";

interface EnvConfig {
    apiUrl: string;
    mediaUrl: string;
    domain: string;
}

const env: Environment = (process.env.NODE_ENV as Environment) || "development";

const environmentVariables: Record<Environment, EnvConfig> = {
    development: {
        apiUrl: "https://cems-api.cgis.asia/api",
        mediaUrl: "https://cems-api.cgis.asia/",
        domain: "http://localhost:3000",
    },
    production: {
        apiUrl: "https://cems-api.cgis.asia/api",
        mediaUrl: "https://cems-api.cgis.asia/",
        domain: "https://cems.cgis.asia",
    },
};

const config: EnvConfig = environmentVariables[env];

export default config;
